export default __webpack_public_path__ + "static/media/references_xl.1682c35f.jpg";